import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpUtils,
  PageableModel,
  PageableResponse,
  PageableService,
} from '@pwc-bei/common';
import { AuthenticationCookie, AuthenticationService } from '@pwc-bei/security';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CallFaqResource } from '../models/api/callFaq-resource';
import { CallFaq } from '../models/callFaq';

@Injectable({
  providedIn: 'root',
})
export class CallFaqService extends PageableService<CallFaqResource, CallFaq> {
  protected baseUrl: string = environment.apiUrl;
  protected endpoint: string = 'tls-fa-bandi/faq';

  constructor(
    http: HttpClient,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
  ) {
    super(http);
  }

  convertResourceToModel(resource: CallFaqResource): CallFaq {
    return resource;
  }
  convertModelToResource(model: CallFaq): CallFaqResource {
    return model;
  }

  searchPost(
    search: Partial<CallFaqResource>,
    forceHeader?: boolean,
  ): Observable<CallFaqResource[]> {
    const pagination: Partial<PageableModel> = {
      page: search.page,
      size: search.size,
    };

    const params = HttpUtils.toHttpParams({
      ...pagination,
      sort: search.sort,
    });

    const headers = forceHeader ? this.getHeader() : undefined;

    return this.http
      .post(this.buildEndpointUrl('search'), search, { headers, params })
      .pipe(
        map((response: PageableResponse<CallFaqResource[]>) =>
          this.extractPaginationInfo(response),
        ),
        map((list: CallFaqResource[]): CallFaq[] =>
          this.convertListToModel(list),
        ),
      );
  }

  private getHeader(): HttpHeaders {
    const currentUser: AuthenticationCookie =
      this.authenticationService.cookieValue;
    const lang =
      this.translateService.currentLang != null
        ? this.translateService.currentLang
        : 'it';
    let headers: HttpHeaders;
    if (currentUser && currentUser.access_token) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${currentUser.access_token}`,
        'Accept-Language': `${lang.toLowerCase()}-${lang.toUpperCase()}`,
        'Content-Type': 'application/json',
      });
    }
    return headers;
  }

  public getCategories(): Observable<Array<string>> {
    const url = this.buildEndpointUrl('categories');
    return this.http.get<Array<string>>(url);
  }
}
